__turbopack_context__.v({
  "content": "BannerNotifications-module-scss-module__hU-kna__content",
  "empty": "BannerNotifications-module-scss-module__hU-kna__empty",
  "list": "BannerNotifications-module-scss-module__hU-kna__list",
  "title": "BannerNotifications-module-scss-module__hU-kna__title",
});
